import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

interface LocalizedTemplate {
  id: string;
  locale?: string | Nullish;
  isPrimary?: boolean;
}

/**
 * Resolves the invoice (faktura) template id to send to the issue endpoints so the document is
 * generated in the user-selected locale. Mirrors the locale matching used on the Documents tab: a
 * template with no locale matches any selected locale.
 *
 * Priority: locale-matching primary template -> first locale-matching template -> fallback (the
 * definition's primary template). Returns `undefined` when disabled or nothing resolves, letting
 * the backend pick its default template.
 */
export const getInvoiceTemplateId = (
  templates: LocalizedTemplate[],
  selectedLocale: string | Nullish,
  fallbackTemplateId: string | Nullish,
  isEnabled: boolean
): string | undefined => {
  if (!isEnabled) {
    return undefined;
  }

  const isLocaleMatch = (locale: string | Nullish) => isNil(locale) || locale === selectedLocale;

  return (
    templates.find((template) => template.isPrimary && isLocaleMatch(template.locale))?.id ??
    templates.find((template) => isLocaleMatch(template.locale))?.id ??
    fallbackTemplateId ??
    undefined
  );
};
